import { render, staticRenderFns } from "./MsLayout.vue?vue&type=template&id=2e4df8c4"
import script from "./MsLayout.vue?vue&type=script&lang=js"
export * from "./MsLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports